<template>
<div class="container">
	<div class="page page-dashboard" v-if="isUserCan('dashboard_view')">
		<div class="page-header">
			<div class="row">
				<div class="col-6">
					<h1 class="page-title mb-0">{{ $t('menu.dashboard') }}</h1>
				</div>
				<div class="col-6">
					<div class="page-header-right text-right">
						<daterangepicker
							:presets="filterDatePresets"
							@selected="setFilterDate">
						</daterangepicker>
					</div>
				</div>
			</div>
		</div>

		<div class="page-content">
			<!-- Transaction -->
			<div class="section-summary">
				<div class="section-summary-title">{{ $t('Transaksi bulan ini') }}</div>
				<div class="row">
					<div class="col-sm-12">
						<overviews
							:overview="overview"
							:items="overviewItems.transaction"
							:layout="'large'"
							:capabilities="user.capabilities">
						</overviews>
					</div>
					<div class="col-sm-12">
						<overviews
							:overview="overview"
							:items="overviewItems.profit"
							:layout="'auto'"
							:capabilities="user.capabilities">
						</overviews>
					</div>
				</div>
			</div>

			<!-- Revenue -->
			<div class="section-summary">
				<div class="row">
					<div class="col-sm-12 col-md-6">
						<div class="section-summary-title">{{ $t('Analisis Penjualanmu') }}</div>
						<div class="box">
							<!-- <div class="box__title"><b>Daily Transaction</b></div> -->
							<div class="box__content">
								<transaction-chart
									class="chart"
									:chartId="transactionChartData.chartId"
									:options='transactionChartOptions'
									:chart-data="transactionChartData">
								</transaction-chart>
							</div>
						</div>
					</div>
					<div class="col-sm-12 col-md-6">
						<div class="section-summary-title">{{ $t('Revenue') }}</div>
						<div class="box">
							<!-- <div class="box__title"><b>Daily Revenue</b></div> -->
							<div class="box__content">
								<revenue-chart
									class="chart"
									:chartId="revenueChartData.chartId"
									:options='revenueChartOptions'
									:chart-data="revenueChartData">
								</revenue-chart>
							</div>
						</div>
					</div>
				</div>
				<!-- Profits -->
				<!-- <overviews
					:layout="'large'"
					:overview="overview"
					:items="overviewItems.revenue"
					:capabilities="user.capabilities">
				</overviews>
				<overviews
					:layout="'large'"
					:overview="overview"
					:items="overviewItems.profit"
					:capabilities="user.capabilities">
				</overviews> -->
			</div>
			<!-- Disabled By Request -->
			<!-- Featured Products -->
			<!-- Profitable -->
			<!-- <div class="section-featured-products">
				<featured-products
					:title="$t('Profitable Products')"
					:products="profitableProducts"
					:highlight="'revenue'">
				</featured-products>
			</div> -->
			<!-- High Demand -->
			<div class="section-featured-products">
				<featured-products
					:title="$t('High Demand Products')"
					:products="highDemandProducts"
					:highlight="'transaction'">
				</featured-products>
				<div class="col-12 d-flex justify-content-center mt-3" @click="nextPage" v-if="highDemandProductsPagination && highDemandProductsPagination.current_page != highDemandProductsPagination.last_page">
					<button type="button" class="btn-outline o-lg outline-primary" :class="{'is-loading' : isLoading}">Lihat Semua</button>
				</div>
			</div>
			<!-- Disabled By Request -->
			<!-- High Convertion -->
			<!-- <div class="section-featured-products">
				<featured-products
					:title="$t('High Converting Products')"
					:products="highConvertingProducts"
					:highlight="'paid-ratio'">
				</featured-products>
			</div> -->
		</div>
	</div>
	<div
		class="page page-dashboard"
		v-if="user && !isUserCan('dashboard_view') && !isDropshipper">
		<div class="profile-picture mt-5" v-if="picture !== ''">
			<label class="profile-picture-upload">
				<img :src="picture" class="profile-picture-image">
			</label>
		</div>
		<div class="d-flex align-items-center justify-content-center" style="height: 80vh;" v-else>
			<img src="https://cdn.ostock.id/img/welcome.png" width="300px">
			<div class="ml-5">
				<div class="content">
					<h2 class="mt-4 text-primary">Welcome, {{ name }}</h2>
					<p>
						Welcome to your dashboard! We're excited to have you here and hope you find<br>this platform useful for managing your product & orders. Let's get started!
					</p>
				</div>
			</div>
			<!-- <i class="material-icons md-240 mt-4">account_circle</i> -->
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Overviews from '../components/Overviews.vue';
import FeaturedProducts from '../components/FeaturedProducts.vue';
import Daterangepicker from '../components/Daterangepicker.vue';
import TransactionChart from '../components/charts/TransactionChart.vue';
import RevenueChart from '../components/charts/RevenueChart.vue';
import productApi from '@/api/products';
import { getDateRange } from '../lib/helper';

const defaultFilterDate = getDateRange();

export default {
	name: 'dashboard',
	data() {
		return {
			isLoading: false,
			page: 1,
			limit: 6,
			overviewItems: {
				transaction: ['submission_count', 'shipping_processed', 'shipping_pending', 'shipping_delivery', 'shipping_completed'],
				others: ['bump_count', 'bump_revenue', 'coupon_discount_claimed', 'shipping_cost'],
				revenue: ['quantity', 'cogs', 'unpaid_revenue', 'gross_revenue'],
				profit: ['gross_profit', 'handling_fee'],
				// profit: ['net_revenue', 'gross_profit', 'expense', 'net_profit'],
			},
			filterDate: defaultFilterDate,
			highDemandProducts: null,
			highDemandProductsPagination: null,
		};
	},
	components: {
		Overviews,
		FeaturedProducts,
		TransactionChart,
		RevenueChart,
		Daterangepicker,
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
		}),
		nextPage() {
			this.isLoading = true;
			this.limit = this.highDemandProductsPagination.total_all_products;
			this.fetchHighDemandProduct();
			// this.$store.dispatch('isShowAllHighDemandProduct', true);
		},
		fetchData() {
			const dateFormat = 'YYYY-MM-DD';

			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);

			// Fetch Statistic
			this.$store.dispatch('fetchStatistic', {
				since: startDate,
				until: endDate,
				product_id: 0,
			});

			// Fetch Snapshot
			this.$store.dispatch('fetchDailyStatistic', {
				since: startDate,
				until: endDate,
				product_id: 0,
			});

			// disabled by request
			// Fetch Profitable Products
			// const profitableParams = {
			// 	commitName: 'setProfitableProducts',
			// 	query: {
			// 		limit: 3,
			// 		sort_by: 'gross_profit',
			// 		sort: 'desc',
			// 		page: 1,
			// 		keyword: '',
			// 		since: startDate,
			// 		until: endDate,
			// 		enable_status_sorting: false,
			// 	},
			// };
			// this.$store.dispatch('fetchFeaturedProducts', profitableParams);

			// move to new endpoint
			// Fetch Profitable Products
			// const highDemandParams = {
			// 	commitName: 'setHighDemandProducts',
			// 	query: {
			// 		limit: this.limit,
			// 		sort_by: 'transaction_count',
			// 		sort: 'desc',
			// 		page: this.page,
			// 		keyword: '',
			// 		since: startDate,
			// 		until: endDate,
			// 		enable_status_sorting: false,
			// 	},
			// };
			// this.$store.dispatch('fetchFeaturedProducts', highDemandParams);

			// disabled by request
			// Fetch Profitable Products
			// const highConvertingProductsParams = {
			// 	commitName: 'setHighConvertingProducts',
			// 	query: {
			// 		limit: 3,
			// 		sort_by: 'paid_ratio',
			// 		sort: 'desc',
			// 		page: 1,
			// 		keyword: '',
			// 		since: startDate,
			// 		until: endDate,
			// 		enable_status_sorting: false,
			// 	},
			// };
			// this.$store.dispatch('fetchFeaturedProducts', highConvertingProductsParams);
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			this.fetchData();
			this.fetchHighDemandProduct();
		},
		fetchHighDemandProduct() {
			const dateFormat = 'YYYY-MM-DD';

			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);

			const callback = (response) => {
				this.highDemandProducts = response.data.products;
				this.highDemandProductsPagination = response.data.page_info;
			};
			const errorCallback = () => {
				this.$notify({
					group: 'products',
					type: 'error',
					title: 'Failed',
					text: '',
				});
			};

			const params = {
				since: startDate,
				until: endDate,
				limit: this.limit,
			};

			productApi.getHighDemandProduct(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			capabilities: 'capabilities',
			isDropshipper: 'isDropshipper',
			isUserCan: 'isUserCan',
			overview: 'overview',
			profitableProducts: 'profitableProducts',
			isShowAllHighDemandProduct: 'isShowAllHighDemandProduct',
			highConvertingProducts: 'highConvertingProducts',
			transactionChartOptions: 'transactionChartOptions',
			revenueChartOptions: 'revenueChartOptions',
			transactionChartData: 'transactionChartData',
			revenueChartData: 'revenueChartData',
			filterDatePresets: 'filterDatePresets',
		}),
		name() {
			return this.user ? this.user.name : '';
		},
		picture() {
			return this.user ? this.user.picture : '';
		},
	},
	created() {
		// this.fetchUser();
		this.fetchHighDemandProduct();
		// if (this.capabilities.indexOf('dashboard_view') !== -1 || this.isUserCan('dashboard_view')) {
		// 	this.fetchData();
		// }
		// else {
		// 	// this.$router.push({ path: 'products/dropship' });
		// }
		// } else {
		// 	console.log('tidak');
		// 	// this.fetchUser();
		// 	this.$router.push({ path: 'products/dropship' });
		// }
	},
	watch: {
		user() {
			if (this.isUserCan('dashboard_view')) {
				this.fetchData();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.section-summary {
	margin-bottom: 2rem;
}

.section-summary-title {
	margin-bottom: 1rem;
	text-align: left;
	font-size: 1.5em;
	font-weight: bold;
}

.chart {
	height: 273px;
}

.section-featured-products {
	margin-bottom: 3rem;
}
</style>
